module.exports = __webpack_public_path__ + "img/graph.2834fce9.png";